import { useEffect, useRef, useState } from "react";

/**
 * Counts from 0 up to the number, fast at first and easing out, so a score lands rather than appears.
 * Used on the breef score and on the total at the end.
 */
export const useCountUp = (target: number, start: boolean, ms = 900) => {
  const [value, setValue] = useState(0);
  const frame = useRef<number>();
  useEffect(() => {
    if (!start) return undefined;
    const began = performance.now();
    const step = (now: number) => {
      const part = Math.min(1, (now - began) / ms);
      setValue(Math.round(target * (1 - (1 - part) ** 3)));
      if (part < 1) frame.current = requestAnimationFrame(step);
    };
    frame.current = requestAnimationFrame(step);
    return () => {
      if (frame.current) cancelAnimationFrame(frame.current);
    };
  }, [target, start, ms]);
  return value;
};
